import type { ButtonHTMLAttributes } from "react";
import styled from "styled-components";
import { colors } from "../../styles/colors";
import { ButtonText } from "../../styles/stringStyles";
import { LoadingSpinner } from "../loading/LoadingSpinner";
import { CustomButton } from "./CustomButton";

export type MainButtonProps = {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  color?: string;
  className?: string;
} & Pick<ButtonHTMLAttributes<HTMLButtonElement>, "aria-describedby" | "aria-label">;

export const MainButton = (props: MainButtonProps) => {
  const { text, onClick, disabled, loading, color, className, ...ariaRest } =
    props;
  return (
    <StyledCustomButton
      onClick={onClick}
      disabled={disabled}
      $color={color}
      className={className}
      {...ariaRest}>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <StyledButtonText>{text}</StyledButtonText>
      )}
    </StyledCustomButton>
  );
};

const StyledCustomButton = styled(CustomButton)<{ $color?: string }>`
  padding: 0 20px;
  border-radius: 100px;
  height: 50px;
  min-width: 200px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-color: ${(props) => props.$color || colors.primary};
`;

const StyledButtonText = styled(ButtonText)`
  color: ${colors.white};
  position: relative;
  z-index: 1;
`;
